import { render, staticRenderFns } from "./Logindia.vue?vue&type=template&id=5884ed9d&scoped=true&"
import script from "./Logindia.vue?vue&type=script&lang=js&"
export * from "./Logindia.vue?vue&type=script&lang=js&"
import style0 from "./Logindia.vue?vue&type=style&index=0&id=5884ed9d&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5884ed9d",
  null
  
)

export default component.exports